import { render, staticRenderFns } from "./ProgressModule.vue?vue&type=template&id=634ad8a5&scoped=true"
import script from "./ProgressModule.vue?vue&type=script&lang=js"
export * from "./ProgressModule.vue?vue&type=script&lang=js"
import style0 from "./ProgressModule.vue?vue&type=style&index=0&id=634ad8a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634ad8a5",
  null
  
)

export default component.exports